<template>
  <div style="position: relative">
    <base-nav type="default" effect="dark" expand>
      <router-link
        class="navbar-brand"
        :to="{ name: 'main' }"
        aria-label="Back to home"
        tabindex="1"
      >
        <img style="height: 44px;" :src="logoLight || logoDark" alt="" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <router-link :to="{ name: 'main' }">
            <img style="height: 54px;" :src="logoLight || logoDark" />
          </router-link>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav ml-lg-auto">
        <li class="nav-item">
          <router-link
            class="nav-link nav-link-icon"
            :to="{ name: 'logout' }"
            tabindex="2"
          >
            Logout
          </router-link>
        </li>
        <base-dropdown tag="li" :position="'right'" :hideArrow="true">
          <base-button
            slot="title"
            type="default"
            class="dropdown-toggle"
            style="margin-top: 8px;display: flex;align-items: center;"
            aria-label="Open notifications"
            tabindex="3"
          >
            <span
              style="font-size: 20px;margin-right: 0px;"
              class="fa fa-bell"
              :class="{ 'text-success': notifications.length }"
              aria-hidden="true"
            ></span>
            <badge pill type="secondary" v-if="notifications.length">{{
              notifications.length
            }}</badge>
          </base-button>
          <li class="noNot" v-if="!notifications.length">
            <span class="fa fa-bell" style="margin-right: 8px"></span>
            <span>No Notifications</span>
          </li>
          <li
            class="dropdown-item"
            style=""
            v-for="(not, i) of notifications"
            :key="i"
          >
            <div class="msgHolder">
              <div
                @click="notGoTo(not.link || null)"
                :class="'icon-shape-' + not.type"
                class="icon icon-shape mb-4 icon-shape-success rounded-circle"
                style="margin: 0 14px 0 0 !important;"
              >
                <i :class="not.icon"></i>
              </div>
              <div
                class="notMsg"
                @click="notGoTo(not.link || null)"
                v-html="not.message"
              ></div>
              <i class="fa fa-times" @click="ackNot(not.ID, i)"></i>
            </div>
          </li>
        </base-dropdown>
      </ul>
    </base-nav>
    <div class="loaderDiv bringIn" v-if="loading">
      <div class="loader-box-Div">
        <div class="loaderDots">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="timeoutModal"
      modal-classes="modal modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Are you still working?
      </h6>

      <div class="py-3 text-center">
        <i style="color: #11cdef;" class="fa fa-clock-o fa-3x"></i>
        <h4 class="heading mt-4">
          Timeout in
          <span style="font-weight: bold;">{{ timeLeft }}</span> seconds
        </h4>
        <p class="lead">
          Are you still working?
        </p>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="default"
          class="ml-auto"
          @click="stopCountDown"
        >
          Yes
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { pop } from "../services/message";
import { renew } from "../services/auth";
import Vue from "vue";
import { io } from "socket.io-client";
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      notifications: [],
      logoLight: this.$theme.logo.light,
      logoDark: this.$theme.logo.dark,
      timeoutModal: false,
      inactivity: null,
      countdown: null,
      timeLeft: 30,
      activityTime: 60000 * 10,
      timeoutCheck: false,
      loading: false
    };
  },
  created() {
    this.connectToNotifications();
    window.addEventListener("theme", () => {
      this.logoLight = this.$theme.logo.light;
      this.logoDark = this.$theme.logo.dark;
    });
    this.ActivityListener();
    this.setActivityTimer();
    window.addEventListener("loading-true", () => {
        this.loading = true
    });
    window.addEventListener("loading-false", () => {
      this.loading = false
    });
  },
  destroyed() {
    Vue.socket.disconnect();
    this.stopCountDown();
    clearTimeout(this.inactivity);
  },
  methods: {
    async Timeout() {},
    setActivityTimer() {
      clearTimeout(this.inactivity);
      this.inactivity = setTimeout(() => {
        this.openInactiveModal();
      }, this.activityTime);
    },
    ActivityListener() {
      document.body.addEventListener("click", () => {
        this.setActivityTimer();
        if (this.timeoutModal) {
          this.stopCountDown();
        }
      });
    },
    openInactiveModal() {
      this.startCountDownToLogOff();
      this.timeoutModal = true;
      this.timeoutCheck = true;
    },
    async startCountDownToLogOff() {
      this.countdown = setInterval(async () => {
        --this.timeLeft;

        if (this.timeLeft === 0) {
          clearTimeout(this.inactivity);
          Vue.socket.disconnect();
          this.timeoutCheck = false;
          this.$router.push("/logout");
        }
      }, 1000);
    },
    async stopCountDown() {
      clearInterval(this.countdown);
      this.timeoutModal = false;
      this.timeLeft = 30;
      if (this.timeoutCheck) {
        try {
          let check = await renew();
          if (!check.accessToken || !check.trusted) {
            Vue.socket.disconnect();
            window.location.href = `${this.publicPath}logout`;
          }
        } catch (error) {
          Vue.socket.disconnect();
          window.location.href = `${this.publicPath}logout`;
        }
      }
    },
    async connectToNotifications() {
      let token = window.sessionStorage.getItem("access_token");
      token = token.replace("Bearer ", "");
      let puid = window.sessionStorage.getItem("puid");

      Vue.socket = io({
        path: `${this.publicPath}socket/`,
        transports: ["websocket"],
        auth: {
          token,
          puid,
          domain: window.location.hostname,
          product: Vue.product,
        },
      });

      Vue.socket.on("connect", () => {
        console.info("Connected");
      });

      Vue.socket.on("disconnect", () => {
        Vue.socket = null;
        console.info("Disconnected");
      });

      Vue.socket.on("notifications", (msg) => {
        this.notifications.push(msg);
        pop(msg.message, msg.type, msg.icon);
      });
    },
    notGoTo(link) {
      if (link && link.name && link.params) {
        this.$router.push(link);
      }
    },
    async ackNot(id, i) {
      Vue.socket.emit("acknowledgeNotification", id);
      this.notifications.splice(i, 1);
    },
  },
};
</script>
<style lang="scss">
.noNot {
  display: flex;
  align-items: center;
  padding: 1rem;
  justify-content: center;
  color: #adb5bd;
}
.msgHolder {
  display: flex;
  align-items: center;
  width: 320px;
  .icon-shape {
    width: 40px;
    height: 40px;
  }
  .notMsg {
    white-space: normal;
    float: left;
    width: 100%;
    height: auto;
    word-wrap: break-word;
  }
}
.loaderDiv {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: 0;
  height: 100vh;
  background: #fffc;
  margin: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 180px;
  z-index: 999;
}
.loader-box-Div {
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  position: relative;
  i {
    font-size: 30px;
  }
}
.loaderDot {
  position: absolute;
  top: 50%;
  left: 40%;
  margin-left: 10%;
  transform: translate3d(-50%, -50%, 0);
}
.dot {
  width: 36px;
  height: 36px;
  background: #3ac;
  border-radius: 100%;
  display: inline-block;
  animation: slide 1s infinite;
}
.dot:nth-child(1) {
  animation-delay: 0.1s;
  background: #11cdef;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
  background: #5e72e4;
}
.dot:nth-child(3) {
  animation-delay: 0.3s;
  background: #fb6340;
}
.dot:nth-child(4) {
  animation-delay: 0.4s;
  background: #11cdef;
}
.dot:nth-child(5) {
  animation-delay: 0.5s;
  background: #2dce89;
}
@-moz-keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}
@-webkit-keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}
@-o-keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes slide {
  0% {
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
}


.spin1 {
  animation: spin3D 1.8s linear 0s infinite;
}
.spin2 {
  animation: spin3D 2.2s linear 0s infinite;
}
.spin3 {
  animation: spin3D 2.2s linear 0s forwards;
}
.opacityChange {
  animation: opacityFade 1.2s linear 0s forwards;
}
.bringOut {
  animation: fadeIn 1.2s linear 0s backwards;
}
.bringIn {
  animation: fadeIn 1.2s linear 0s forwards;
}
@keyframes scale {
  form {
    font-size: 10px;
    opacity: 0;
  }
  to {
    font-size: 40px;
    opacity: 1;
  }
}

@keyframes fadeIn {
  form {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes opacityFade {
  form {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}
</style>
